<template>
    <div class="py-9 flex flex-col">
        <h3 class="text-lg font-black tracking-wider px-9">{{ heading }}</h3>

        <div class="max-h-[280px] overflow-y-auto px-9 space-y-1 mt-3">
            <div
                class="flex gap-3 items-center"
                v-for="(option, key) in options"
                :key="key"
            >
                <input
                    type="checkbox"
                    :id="index + key"
                    :checked="filterInUse(option)"
                    :value="true"
                    :disabled="optionDisabled(option) && !filterInUse(option)"
                    @click="toggleFilter(option)"
                    class="peer cursor-pointer disabled:cursor-auto"
                />
                <label :for="index + key" class="text-black peer-disabled:text-xp-medium-grey text-lg font-normal">
                    {{ option.val + (option.unit || '') }}
                </label>
            </div>
        </div>

        <div class="px-9 mt-8 flex">
            <input
                aria-label="min"
                ref="min_input"
                type="number"
                placeholder="Min"
                :disabled="loading"
                class="w-1/3 px-1.5 text-sm font-normal tracking-wider uppercase border-2 border-xp-carbon focus:border-xp-carbon focus:ring-0 rounded-l"
                :value="minValue"
                v-debounce:1250ms="changeRangeMin"
            />
            <input
                aria-label="max"
                ref="max_input"
                type="number"
                placeholder="Max"
                :disabled="loading"
                class="w-1/3 px-1.5 text-sm font-normal tracking-wider uppercase border-y-2 border-x-0 border-xp-carbon focus:border-xp-carbon focus:ring-0"
                :value="maxValue"
                v-debounce:1250ms="changeRangeMax"
            >
            <select
                aria-label="unit"
                class="w-1/3 pl-1.5 pr-5 bg-[length:16px] bg-[position:90%_50%] text-sm font-normal tracking-wider uppercase border-2 border-xp-carbon focus:border-xp-carbon focus:ring-0 rounded-r"
                @input="changeRange($event,'unit')"
            >
                <option
                    v-for="(unit, i) in unitOptions"
                    :key="i"
                    :value="unit"
                    :selected="unitSelected(unit)"
                >
                    {{ unit }}
                </option>
            </select>
        </div>

        <div v-if="heading === 'Output Voltage 1'" class="px-9 pt-4">
            <p class="text-[12px] tracking-[2.51px] font-bold uppercase">
                <span class="text-xp-lilac">For outputs >500V, see</span>
                <a :href="'/products/high-voltage-power-solutions'" class="underline underline-offset-4 decoration-2 decoration-xp-lilac hover:decoration-xp-electron-green">high voltage selector tool.</a>
            </p>
        </div>


        <div class="px-9 pt-7 mt-auto flex justify-end">
            <button
                type="button"
                class="text-sm tracking-[2.51px] font-black uppercase underline underline-offset-4 decoration-2 decoration-xp-lilac hover:decoration-xp-electron-green"
                v-on:click="rangeFilterReset"
            >
                Reset
            </button>
        </div>
    </div>
</template>

<script>
import Filter from '../../../../../mixins/filters/Filter'

export default {
    name: 'ProductRangeOptionFilter',
    mixins: [Filter],
    props: {
        unitOptions: {
            type: Array,
            required: true
        },
        defaultUnit: {
            type: String,
            required: true
        },
        loading: {
            type: Boolean,
            required: false
        },
    },
    computed: {
        minValue() {
            return this.activeFilters?.range?.min
        },
        maxValue() {
            return this.activeFilters?.range?.max
        }
    },
    methods: {
        changeRange(e, property) {
            this.$emit('change-range', this.index, property, e.target.value)
        },
        changeRangeMin(value, event) {
            if (this.$refs.min_input.value !== '' && this.$refs.max_input.value !== '') {
                this.changeRange(event, 'min')

                if (this.maxValue !== this.$refs.max_input.value) {
                    this.$emit('change-range', this.index, 'max', this.$refs.max_input.value)
                }
            }
            else if (this.$refs.min_input.value === '' && this.$refs.max_input.value === '') {
                this.$emit('filter-reset', null)
            }
        },
        changeRangeMax(value, event) {
            if (this.$refs.min_input.value !== '' && this.$refs.max_input.value !== '') {
                this.changeRange(event, 'max')

                if (this.minValue !== this.$refs.min_input.value) {
                    this.$emit('change-range', this.index, 'min', this.$refs.min_input.value)
                }
            }
            else if (this.$refs.min_input.value === '' && this.$refs.max_input.value === '') {
                this.$emit('filter-reset', null)
            }
        },
        rangeFilterReset() {
            this.$refs.min_input.value = null
            this.$refs.max_input.value = null
            this.$emit('filter-reset', this.index)
        },
        unitSelected(option_unit) {
            // if this filter has a unit set, check if the option matches it,
            // else check it matches the default unit
            const active_unit = this.activeFilters?.range?.unit

            return active_unit
                ? active_unit === option_unit
                : option_unit === this.defaultUnit
        }
    }
}
</script>
